import { NeoModel, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../../../Common/TextConstants";

@NeoModel
export default class AuthorisableUpdateRequestSearchCriteria extends ValueObject
{
  public status: string = TextConstants.GeneralText.Pending
}